<template>
    <div class="wrap">
        <!-- <iframe src="iframesrc" frameborder="0" style="width:100%;height:100%;border:0;min-width: 1400px;"></iframe> -->
        <CHeader :hideMenu="hideMenu" />
        <iframe :src="iframesrc" frameborder="0" style="width:100%;height:100%;border:0;min-width: 1400px;"></iframe>
    </div>
</template>

<script>
import CHeader from "../exhibition/components/Headers";
import { mapState } from "vuex";

export default {
    data() {
        return {
            iframesrc: '',
            hideMenu: false,
            isPavilion: true
        }
    },
    computed: {
        ...mapState(["userInfo","language"]),
    },
    mounted() {
        this.iframesrc = 'https://720.cloudvhall.com/shidai/49-pc'
    },
    methods:{
        handleChangeIsPavilion(){
            this.isPavilion = !this.isPavilion
        },
        goIsHolding(_id){
            this.$router.push({
                path: '/area/zhanqu',
                query:{
                    exhibition_id: _id,
                    status: '0',
                }
            })
            // if(_id == '34'){
                
            // }else{
            //     this.$router.push({
            //         path: '/area/consult',
            //         query:{
            //             exhibition_id: _id,
            //             status: '0',
            //         }
            //     })
            // }
        },
    },
    components: {
        CHeader,
    },

}
</script>

<style lang="scss" scoped>
.wrap{
    min-width: 1400px;
    width: 100%; 
    height: 100vh;
    background-size: 100% 100%;
    position: relative;
    .show-pavilion{
        opacity: 0.7;
        position: absolute;
        top: 40%;
        left: 0;
        display: flex;
        align-items: center;
        z-index: 999;
        .show-pavilion-content{
            width: 280px;
            background: #ffffff;
            border-radius: 0px 20px 20px 0px;
            padding: 24px 24px 6px;
            .title{
                display: flex;
                align-items: center;
                .line{
                    width: 4px;
                    height: 20px;
                    background: #09468c;
                    margin-right: 4px;
                }
                .title-name{
                    font-size: 20px;
                    font-weight: 500;
                    color: #09468c;
                    line-height: 28px;
                }
            }
            .item{
                margin-top: 17px;
                .item-wrap{
                    margin-bottom: 18px;
                    cursor: pointer;
                    .item-name{
                        font-size: 14px;
                        text-align: left;
                        color: #333;
                        line-height: 22px;
                        font-weight: 400;
                        margin-bottom: 8px;
                    }
                    .item-time{
                        border: 1px solid #8390a8;
                        border-radius: 12px;
                        width: 99px;
                        height: 20px;    
                        font-size: 12px;   
                        color: #666;
                        line-height: 20px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                }
            }
        }
        .hide-pavilion-content{
            display: flex;
            align-items: center;
            width: 20px;
            height: 80px;
            opacity: 0.7;
            background: #ffffff;
            border-radius: 0px 10px 10px 0px;
            cursor: pointer;
            .arrow-icon{
                color: #333;
            }
        }
    }
    .hide-pavilion{
        opacity: 0.7;
        position: absolute;
        top: 48%;
        left: 0;
        border-radius: 0px 10px 10px 0px;
        width: 20px;
        height: 80px;
        display: flex;
        background: #ffffff;
        align-items: center;
        cursor: pointer;
        .arrow-icon{
            color: #333;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/shuzijiaoyu/index.vue